import { GET_LEADS_STATUS, GET_LEADS_STATUS_SUCCESS, GET_LEADS_STATUS_FAILURE } from '../constants/leads_status.constants';

export const getLeadsStatusRequest = () => ({
    type: GET_LEADS_STATUS,
});

export const getLeadsStatusSuccess = lead_status_list => ({
    type: GET_LEADS_STATUS_SUCCESS,
    lead_status_list,
});

export const getLeadsStatusFailure = error => ({
    type: GET_LEADS_STATUS_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_leads_status.actions.js